import { CampaignsApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const campaignApi = new CampaignsApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
